import React from "react";
import {
    MessageBar,
    MessageBarType,
    nuOrderTheme as theme,
    IMessageBarStyles,
    IMessageBarProps,
} from "@nuorder/components";

interface IMessageBar extends IMessageBarProps {
    message: string;
    dataTest?: string;
    messageBarType: MessageBarType;
}
export const MessageNotification: React.FunctionComponent<IMessageBar> = ({
    message,
    dataTest,
    messageBarType,
    onDismiss,
    ...restProps
}) => {
    const styles = React.useMemo<Partial<IMessageBarStyles>>(() => {
        if (messageBarType === MessageBarType.error) {
            return {
                root: {
                    marginTop: "4px",
                    border: `1px solid ${theme.palette.errorLight}`,
                    borderRadius: 4,
                    background: theme.palette.errorLighter,
                    " svg": {
                        fill: theme.palette.errorBase,
                    },
                },
                content: {
                    alignItems: "center",
                    " .ms-Button-icon": {
                        color: `${theme.palette.errorBase} !important`,
                    },
                },
                text: {
                    color: theme.palette.errorBase,
                },
            };
        }

        return {}; // No defined styles for other alerts
    }, [messageBarType]);

    return (
        <MessageBar
            {...restProps}
            messageBarIconProps={{
                iconName: "alertCircle24",
            }}
            styles={styles}
            data-test={dataTest}
            messageBarType={messageBarType}
            isMultiline={true}
            dismissButtonAriaLabel="Close"
            onDismiss={onDismiss}
        >
            {message}
        </MessageBar>
    );
};
